const cookie = require('cookie-cutter');
const q = require('queried');
const events = require('events-mixin');
const ajax = require('component-ajax');

const kudago = require('./kudago');
const _ = require('./i18n');
const { showLoginPopup } = require('./utils');

class Contest {
  constructor({ element, _deps }) {
    this.element = element;
    this.form = q('form', this.element);

    // mocking for tests
    this._deps = _deps || { _ };

    if (this.form) {
      this.id = this.form.getAttribute('data-id');
      this.url = this.form.getAttribute('action');

      this.bindEvents();
    }
  }

  /**
   * Bind DOM events handlers
   */
  bindEvents() {
    this.events = events(this.element, this);
    const selectors = '.contest-button, .single-contest-button, .random-contest-participate-button';
    this.events.bind({
      [`click ${selectors}`]: (e) => this.handleButtonClick(e),
    });
  }

  /**
   * Handle 'participate' button click
   * Shows terms, suggests to login or sends participations request
   * depending on some global conditions
   * @param  {Event} e - click event
   */
  handleButtonClick(e) {
    e.preventDefault();

    if (kudago.user.isAuthenticated) {
      this.sendParticipationRequest();
    } else {
      showLoginPopup({
        reason: 'contest',
      });
    }
  }

  /**
   * Send participation ajax request
   */
  sendParticipationRequest() {
    const options = this.getAjaxOptions();
    ajax(options);
  }

  /**
   * Get options for participation ajax request
   * @return {Object} - options
   */
  getAjaxOptions() {
    return {
      type: 'POST',
      url: this.url,
      data: { id: this.id },
      headers: {
        'X-CSRFToken': cookie.get('csrftoken'),
      },
      success: () => this.handleParticipation(),
    };
  }

  /**
   * Default callback on successful participation
   */
  handleParticipation() {
    this.form.setAttribute('hidden', true);

    const tagline = q('.contest-tagline', this.element);
    const participation = q('.single-contest-participation', this.element);

    if (tagline) {
      tagline.textContent = this._deps._('Thank you for participating. You can see the details in your profile.');
    }

    if (participation) {
      participation.textContent = this._deps._('Thank you for participating. You can see the details in your profile.');
    }
  }
}

module.exports = Contest;
